"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _CheckboxWithContainer = _interopRequireDefault(require("../../components/checkbox/CheckboxWithContainer"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var REMEMBER_ME = {
  component: _CheckboxWithContainer["default"],
  id: 'rememberMe',
  name: 'rememberMe',
  label: 'Remember me',
  isBordered: true,
  required: true,
  type: 'checkbox',
  checked: false
};
var _default = exports["default"] = REMEMBER_ME;